export const useTestResults = () => {
  const globalStore = useGlobalStore();
  const { countryData } = useCurrentCountryData();
  const resultsUrl = computed(() => {
    const base = globalStore.globalData.patient_login_link.replace(/\/$/, "");
    const countryName = countryData.value?.name;

    return countryName ? `${base}?country=${countryName}` : base;
  });

  return {
    resultsUrl,
  };
};
